import React from "react";
import environment from "../environment";
import { QueryRenderer } from "react-relay";

export default function createQueryRenderer(
  Component,
  {
    query,
    variables = {},
    prepareVariables = () => ({}),
    render = defaultRender,
  }
) {
  return (props) => {
    const params = props.params; //Get params from route and pass them as variables
    return (
      <QueryRenderer
        environment={environment}
        query={query}
        variables={{ ...prepareVariables(params), ...variables }}
        render={({ error, props: queryProps }) => {
          if (error) {
            console.error(error);
            return <p>{error.toString()}</p>;
          }
          if (queryProps) {
            return render({ Component, props: { ...props, ...queryProps } });
          }
          return null; //Loading
        }}
      />
    );
  };
}

function defaultRender({ Component, props }) {
  return <Component {...props} />;
}
